export const GET_RULE = "GET_RULE";
export const GET_RULE_SUCCESS = "GET_RULE_SUCCESS";
export const GET_RULE_FAILED = "GET_RULE_FAILED";
